import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Manifesto from "@/components/Manifesto";
import Flagships from "@/components/Flagships";
import Products from "@/components/Products";
import Stats from "@/components/Stats";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import AnnouncementBar from "@/components/AnnouncementBar";
import Admin from "@/pages/Admin";
import Stay from "@/pages/Stay";
import { initLenis, destroyLenis } from "@/lib/scroll";

function Landing() {
  useEffect(() => {
    initLenis();
    return () => destroyLenis();
  }, []);

  return (
    <div className="bg-white text-[#1E2A4A] min-h-screen">
      <div className="grain-overlay" aria-hidden="true" />
      <Nav />
      <main>
        <Hero />
        <Marquee />
        <Manifesto />
        <Flagships />
        <Products />
        <Stats />
        <Contact />
      </main>
      <Footer />
      <AnnouncementBar />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/stay" element={<Stay />} />
        <Route path="/admin" element={<Admin />} />
      </Routes>
      <Toaster theme="light" position="bottom-right" richColors />
    </BrowserRouter>
  );
}

export default App;
